import React from 'react'
import { useNavigate } from 'react-router-dom'
import LaunchAdnexioContainer from 'components/smart/launch-adnexio-container/LaunchAdnexioContainer'
import Typography from '@mui/material/Typography'
import rocket_1 from 'pages/onboarding-lift-off/assets/rocket_1.svg'
import { useQueryClient } from 'react-query'
import AdxButton from 'components/custom/AdxButton'

const OnboardingLiftOff = () => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const handleNavigate = async () => {
    await queryClient.invalidateQueries('myAccountData')
    navigate('/app/homepage')
  }
  return (
    <LaunchAdnexioContainer src={rocket_1}>
      <Typography variant="h1" color="black.main" fontWeight="bold" mb={2}>
        Lift Off!
      </Typography>
      <Typography variant="h4" color="black.main">
        You are all set to use adnexio HR suites.
      </Typography>
      <Typography variant="h4" mb={3.5} color="black.main">
        Explore and enjoy the ride!
      </Typography>
      <AdxButton variant={'contained'} sx={{ width: 200 }} size="standard" onClick={handleNavigate}>
        Launch adnexio
      </AdxButton>
    </LaunchAdnexioContainer>
  )
}

export default OnboardingLiftOff
